<template>
  <div>
    <h4>
      <button
        class="guideline-header-button"
        :aria-expanded="expanded ? 'true' : 'false'"
        @click="expanded = !expanded"
      >
        <span aria-hidden="true"> {{ expanded && '–' || '+' }} </span> {{ title }}
      </button>
    </h4>
    <collapse v-model="expanded">
      <div class="arrow_box" :class="arrowBoxClass(principle)">
        <CheckpointStrategyList
          v-for="checkpoint of checkpoints"
          :key="checkpoint.standard_long_ref"
          :title="checkpoint.udl_checkpoint_name"
          :checkpoint-ref="checkpoint.udl_checkpoint"
          :principle="editorVisibility && principle || ''"
          :strategies="checkpoint.adaptations" />
      </div>
    </collapse>
  </div>
</template>

<script>
import CheckpointStrategyList from './CheckpointStrategyList'
import { expandEventMixin } from './mixins'
import { mapGetters } from 'vuex'

export default {
  name: 'UdlGuidelineStrategyPanel',
  mixins: [expandEventMixin],
  components: { CheckpointStrategyList },
  props: {
    title: {
      type: String,
      required: true
    },
    principle: {
      type: String,
      required: true
    },
    checkpoints: {
      type: Array,
      required: true
    }
  },
  computed: {
    ...mapGetters('visibility', ['editorVisibility'])
  },
  methods: {
    arrowBoxClass(principle) {
      return `udl-${principle.toLowerCase()}`
    }
  }
}
</script>

<style scoped lang="less">
.guideline-header-button {
  background-color: transparent;
  border: none;
  text-transform: capitalize;
  font-size: 18px;
  font-weight: 300;
  color: #666;
  margin-top: 8px;

  &:hover {
    text-decoration: underline;
  }
}

.arrow_box {
  &.udl-representation {
    background: rgb(253, 250, 253);
    &:after {
      border-bottom-color: rgb(253, 250, 253);
    }
  }

  &.udl-expression {
    background: rgb(242, 247, 252);
    &:after {
      border-bottom-color: rgb(242, 247, 252);
    }
  }

  &.udl-engagement {
    background: rgb(247, 255, 245);
    &:after {
      border-bottom-color: rgb(247, 255, 245);
    }
  }
}
</style>
